type Variant = "accent" | "success" | "warning" | "danger";
type Size = "sm" | "md" | "lg";

export function Progress({
  value,
  variant = "accent",
  size = "sm",
  showLabel = false,
  labelFormatter,
}: {
  value: number;
  variant?: Variant;
  size?: Size;
  showLabel?: boolean;
  labelFormatter?: (v: number) => string;
}) {
  const v = Math.max(0, Math.min(100, Math.round(value)));
  const color = variant === "success" ? "bg-success" : variant === "warning" ? "bg-warning" : variant === "danger" ? "bg-danger" : "bg-accent";
  const h = size === "lg" ? "h-4" : size === "md" ? "h-3" : "h-2";
  const label = labelFormatter ? labelFormatter(v) : `${v}%`;
  return (
    <div className="flex items-center gap-2">
      <div className={`w-full rounded bg-muted/20 ${h}`}>
        <div className={`${h} rounded ${color}`} style={{ width: `${v}%` }} />
      </div>
      {showLabel && <span className="text-xs text-muted">{label}</span>}
    </div>
  );
}
